import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/Home.vue'
import tuijian from '../views/tuijian.vue'
import toutiao from '../views/toutiao.vue'
import jianbao from '../views/jianbao.vue'
import pinglun from '../views/pinglun.vue'
import gongbao from '../views/gongbao.vue'
import shushuo from '../views/shushuo.vue'
import zhuanjia from '../views/zhuanjia.vue'
import zhengce from '../views/zhengce.vue'
import guihua from '../views/guihua.vue'
import ztgongzuohui from '../views/zhuanti-gongzuohui.vue'
import ztjujiao from '../views/zhuanti-jujiao.vue'
import zthongguan from '../views/zhuanti-hongguan.vue'
import ztshuangtan from '../views/zhuanti-shuangtan.vue'
import ztshuzijingji from '../views/zhuanti-shuzijingji.vue'
import ztxiandaijinrong from '../views/zhuanti-xiandaijinrong.vue'
import ztguojijingji from '../views/zhuanti-guojijingji.vue'
import ztquyufazhan from '../views/zhuanti-quyufazhan.vue'
import ztchanyejingji from '../views/zhuanti-chanyejingji.vue'
import ztlianghui from '../views/zhuanti-lianghui.vue'
import ztchengshigengxin from '../views/zhuanti-chengshigengxin.vue'
import ztxiangcunzhenxing from '../views/zhuanti-xiangcunzhenxing.vue'
import ztxinxingchengzhenhua from '../views/zhuanti-xinxingchengzhenhua.vue'
import ztminyingjingji from '../views/zhuanti-minyingjingji.vue'
import daohang from '../views/daohang.vue'
import wode from '../views/wode.vue'
import search from '../views/search.vue'
import theme from '../views/theme.vue'
import themegj from '../views/themegj.vue'
import detail from '../views/detail.vue'
// import activity from '../views/activity.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
		meta:{
			auth:false
		}
  },
	// {
	//   path: '/activity',
	//   name: 'activity',
	//   component: activity,
	// 	meta:{
	// 		auth:false
	// 	}
	// },
	{
	  path: '/tuijian',
	  name: 'tuijian',
	  component: tuijian,
		meta:{
			auth:true
		}
	},
	{
	  path: '/toutiao',
	  name: 'toutiao',
	  component: toutiao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/jianbao/:column?',
	  name: 'jianbao',
	  component: jianbao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/pinglun/:column?',
	  name: 'pinglun',
	  component: pinglun,
		meta:{
			auth:true
		}
	},
	{
	  path: '/gongbao/:column?',
	  name: 'gongbao',
	  component: gongbao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/shushuo',
	  name: 'shushuo',
	  component: shushuo,
		meta:{
			auth:true
		}
	},
	{
	  path: '/zhuanjia',
	  name: 'zhuanjia',
	  component: zhuanjia,
		meta:{
			auth:true
		}
	},
	{
	  path: '/zhengce/:column?',
	  name: 'zhengce',
	  component: zhengce,
		meta:{
			auth:true
		}
	},
	{
	  path: '/guihua/:column?',
	  name: 'guihua',
	  component: guihua,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztgongzuohui',
	  name: 'ztgongzuohui',
	  component: ztgongzuohui,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztjujiao',
	  name: 'ztjujiao',
	  component: ztjujiao,
		meta:{
			auth:true
		}
	},
	{
	  path: '/zthongguan',
	  name: 'zthongguan',
	  component: zthongguan,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuangtan',
	  name: 'ztshuangtan',
	  component: ztshuangtan,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztshuzijingji',
	  name: 'ztshuzijingji',
	  component: ztshuzijingji,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztxiandaijinrong',
	  name: 'ztxiandaijinrong',
	  component: ztxiandaijinrong,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztguojijingji',
	  name: 'ztguojijingji',
	  component: ztguojijingji,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztquyufazhan',
	  name: 'ztquyufazhan',
	  component: ztquyufazhan,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztchanyejingji',
	  name: 'ztchanyejingji',
	  component: ztchanyejingji,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztlianghui',
	  name: 'ztlianghui',
	  component: ztlianghui,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztchengshigengxin',
	  name: 'ztchengshigengxin',
	  component: ztchengshigengxin,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztxiangcunzhenxing',
	  name: 'ztxiangcunzhenxing',
	  component: ztxiangcunzhenxing,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztxinxingchengzhenhua',
	  name: 'ztxinxingchengzhenhua',
	  component: ztxinxingchengzhenhua,
		meta:{
			auth:true
		}
	},
	{
	  path: '/ztminyingjingji',
	  name: 'ztminyingjingji',
	  component: ztminyingjingji,
		meta:{
			auth:true
		}
	},
	{
	  path: '/daohang',
	  name: 'daohang',
	  component: daohang,
		meta:{
			auth:true
		}
	},
	{
	  path: '/wode/:seltype?',
	  name: 'wode',
	  component: wode,
		meta:{
			auth:true
		}
	},
	{
	  path: '/search/:searchword?',
	  name: 'search',
	  component: search,
		meta:{
			auth:true
		}
	},
	{
	  path: '/theme/:searchword/:pagetype/:colid?',
	  name: 'theme',
	  component: theme,
		meta:{
			auth:true
		}
	},
	{
	  path: '/themegj/:searchword/:pagetype/:colid?',
	  name: 'themegj',
	  component: themegj,
		meta:{
			auth:true
		}
	},
	{
	  path: '/detail/:id/:toutiaoflag?',
	  name: 'detail',
	  component: detail,
		meta:{
			auth:true
		}
	},
	{
	  path: '/*',
	  redirect: '/'
	},
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
	mode: 'history',
  routes
})

export default router
